<template>
  <div class="footer">
    <div class="container">
      <div class="logo-box" @click="$router.push('/');">
        <img src="@/assets/images/logo.png" alt="网站logo" class="logo" />
      </div>
      <div class="inner-content">
        <ul>
          <li class="title">关于我们</li>
          <li>走进我们</li>
          <li>荣誉资质</li>
        </ul>
        <ul>
          <li class="title">产品中心</li>
          <li>翻转台系列</li>
          <li>绕线机系列</li>
          <li>箔绕机系列</li>
          <li class="title mt40">热门产品</li>
          <li>
            电抗器
            <img
              class="icon-fire"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACaADAAQAAAABAAAADAAAAADnohbRAAABIklEQVQYGWNgQAJ/Fzc2/V/eZIgkBGYywgT+NzSw/JL59ZCB4T8vAwOjFXtK2xWYHBOM8U30U+KfH9+k/vz4wQukVwA1weXAJn3qSRP5z8h4GWiCBNAkoD5Ghv//GJz/s/w4J1i44AMLyKRfP37OA0pKMAK1/AeqAdEMjP/9//9inPW6M8mO8UVtaBRQcClIMUwBiAZxgWoZ//9nnM/y79ePvP//IKJAW4BSQAyiwQr+A01lNGL59e2rClgILAwkEIpgbGWWPz+/fwZKCUPUAB0MhIxQo8Cq/jNeYwF6eSWQUw5ShA0ANaxnPBOqxM/FxLoHaIsJzCYQDQV7r/276Q524g0/Ed6fDFw5QO9EA01V+M/AdBcYkovffXw4wfEAwx8AOkZyOVDTlGEAAAAASUVORK5CYII="
            />
          </li>
          <li>
            电阻器
            <img
              class="icon-fire"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACaADAAQAAAABAAAADAAAAADnohbRAAABIklEQVQYGWNgQAJ/Fzc2/V/eZIgkBGYywgT+NzSw/JL59ZCB4T8vAwOjFXtK2xWYHBOM8U30U+KfH9+k/vz4wQukVwA1weXAJn3qSRP5z8h4GWiCBNAkoD5Ghv//GJz/s/w4J1i44AMLyKRfP37OA0pKMAK1/AeqAdEMjP/9//9inPW6M8mO8UVtaBRQcClIMUwBiAZxgWoZ//9nnM/y79ePvP//IKJAW4BSQAyiwQr+A01lNGL59e2rClgILAwkEIpgbGWWPz+/fwZKCUPUAB0MhIxQo8Cq/jNeYwF6eSWQUw5ShA0ANaxnPBOqxM/FxLoHaIsJzCYQDQV7r/276Q524g0/Ed6fDFw5QO9EA01V+M/AdBcYkovffXw4wfEAwx8AOkZyOVDTlGEAAAAASUVORK5CYII="
            />
          </li>
        </ul>
        <ul>
          <li class="title">案例中心</li>
          <li>翻转台系列</li>
          <li>绕线机系列</li>
          <li>箔绕机系列</li>
          <li>合作客户</li>
        </ul>
        <ul>
          <li class="title">新闻中心</li>
          <li>行业动态</li>
          <li>公司新闻</li>
        </ul>
        <ul>
          <li class="title">荣誉资质</li>
          <li>关于我们</li>
          <li>项目介绍</li>
          <li>流程细则</li>
          <li>免责声明</li>
          <li>联系我们</li>
        </ul>
        <ul>
          <li class="title">友情链接</li>
          <li>--</li>
        </ul>
      </div>
      <div class="contact-content">
        <div class="title">联系我们</div>
        <div class="tel">137-2105-2224</div>
        <div class="address">安徽省巢湖市经济开发区花山工业园（S105省道与秀湖路交汇处）</div>
        <!-- <div class="follow">关注我们</div>
        <div class="qrcode">
          <img src="../assets/images/wechat.png" alt="" />
          <img src="../assets/images/weibo.png" alt="" />
        </div> -->
      </div>
    </div>

    <div class="copyright">COPYRIGHT © 合肥祝瑭机电科技有限公司 皖ICP备2022013440号</div>

    <div class="mobile-footer">
      <div class="mobile-footer_mobile" @click="drawerVisible = true">
        <img src="@/assets/images/dianhuazixun.svg" style="vertical-align: middle" />
        电话咨询
      </div>
    </div>

    <el-drawer
      :visible.sync="drawerVisible"
      direction="btt"
      :append-to-body="true"
      :with-header="false"
      custom-class="phonecall-drawer"
      :modal="false"
    >
      <div class="phonecall-drawer-body">
        <div>137-2105-2224</div>
        <div @click="dial">呼叫</div>
        <div @click="copy">复制</div>
        <div @click="drawerVisible = false">取消</div>
      </div>
      <div class="phonecall-drawer-footer"></div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  nanme: 'PageFooter',
  data() {
    return {
      drawerVisible: false,
    };
  },
  methods: {
    //? 呼叫
    dial() {
      window.location.href = `tel:137-2105-2224`;
    },

    //? 复制
    copy() {
      this.drawerVisible = false;
      this.copyToClipboard('137-2105-2224');
    },

    copyToClipboard(textToCopy) {
      // navigator clipboard 需要https等安全上下文
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        this.$message.success('号码已复制到剪贴板');
        return navigator.clipboard.writeText(textToCopy);
      } else {
        // 创建text area
        let textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = 'absolute';
        textArea.style.opacity = 0;
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
          this.$message.success('号码已复制到剪贴板');
        });
      }
    },
  },
};
</script>

<style lang="scss">
.phonecall-drawer {
  height: 36% !important;
  .phonecall-drawer-body {
    & > div {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 14px;
      color: #0f234b;
      border-bottom: 1px solid rgb(246, 248, 253);
      cursor: pointer;
      &:first-child {
        color: #999;
      }
      &:nth-child(3) {
        border-bottom: 10px solid #f4f5fa;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .phonecall-drawer-footer {
    height: 10px;
    background-color: #fff;
    border-top: 1px solid rgb(246, 248, 253);
  }
}
</style>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 452px;
  background-color: #20242d;
  color: #fff;
  // padding: 60px 220px 0;
  position: relative;
  .container {
    width: 1366px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top: 60px;
    .logo {
      cursor: pointer;
      height: 72px;
      margin-top: 10px;
      margin-right: 170px;
    }
    .inner-content {
      display: flex;
      justify-content: space-between;
      // margin-left: 170px;
      // margin-right: 90px;
      ul {
        margin-right: 68px;
        .title {
          font-weight: 600;
          font-size: 18px;
          margin-bottom: 14px;
          line-height: 25px;
          opacity: 1;
        }
        li {
          font-size: 14px;
          line-height: 36px;
          opacity: 0.8;
          .icon-fire {
            width: 9px;
            margin-left: 6px;
          }
        }
        li:not(.title) {
          cursor: pointer;
        }
      }
    }
    .contact-content {
      width: 20%;
      .title {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 14px;
        line-height: 25px;
      }
      .tel {
        font-weight: bold;
        font-size: 30px;
        line-height: 40px;
      }
      .address {
        font-size: 14px;
        margin: 8px 0 24px;
      }
      .follow {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 14px;
      }
      .qrcode {
        img {
          margin-right: 16px;
        }
      }
    }
  }
  .copyright {
    width: 100%;
    height: 50px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    line-height: 30px;
    opacity: 0.8;
  }

  .mobile-footer {
    display: none;
    width: 100%;
    height: 56px;
    position: fixed;
    bottom: 0;
    line-height: 56px;
    background: rgba(255, 255, 255, 0.39);
    backdrop-filter: blur(30px);
    font-weight: 600;
    font-size: 14px;
    color: #0f234b;
    z-index: 100;
    padding-bottom: 8px;
    .mobile-footer_mobile {
      display: inline-block;
      width: 100%;
      flex-shrink: 0;
      text-align: center;
      cursor: pointer;
    }
    .mobile-footer_wexin {
      display: inline-block;
      width: 50%;
      flex-shrink: 0;
      text-align: center;
      cursor: pointer;
    }
  }
}
// @media screen and (max-width: 1000px) {
//   .footer {
//     height: 60px;
//     background-color: transparent;
//     .container,
//     .copyright {
//       display: none;
//     }
//     .mobile-footer {
//       display: block;
//     }
//   }
// }
</style>
